export function getBrandInitials(name: string | null | undefined) {
  if (!name) {
    return "--";
  }

  const words = name.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return "--";
  }

  return words
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? "")
    .join("");
}

export const countryLabels: Record<string, string> = {
  CA: "Canada",
  US: "United States",
};
